import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ArrowLeft, Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { API, useApp } from "@/state/AppContext";
import { toast } from "sonner";

export default function AuthPage() {
  const navigate = useNavigate();
  const { setToken, setUser, language } = useApp();
  const [mode, setMode] = useState("login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    try {
      const url = mode === "login" ? `${API}/auth/login` : `${API}/auth/register`;
      const body = mode === "login"
        ? { email, password }
        : { email, password, name, preferred_language: language };
      const r = await axios.post(url, body);
      setToken(r.data.token);
      setUser(r.data.user);
      if (mode === "login") {
        toast.success("Willkommen zurück!");
        navigate("/");
      } else {
        // Mark that we should show a welcome banner on Home
        try { sessionStorage.setItem("ba_just_registered", "1"); } catch (_) { void 0; }
        toast.success("Willkommen bei BriefAssist!", {
          description: "Deine 7-Tage-Testphase startet jetzt · 2 Dokumente inklusive.",
          duration: 6000,
        });
        navigate("/upload");
      }
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Fehler bei der Anmeldung");
    } finally { setBusy(false); }
  };

  return (
    <div className="px-5 pt-4 pb-8" data-testid="auth-page">
      <button onClick={() => navigate(-1)} data-testid="auth-back" className="text-slate-600 flex items-center gap-1 text-sm mb-3">
        <ArrowLeft className="w-4 h-4" /> Zurück
      </button>
      <h1 className="text-2xl font-bold text-slate-900">
        {mode === "login" ? "Anmelden" : "Konto erstellen"}
      </h1>
      <p className="text-slate-600 mt-1">
        {mode === "login" ? "Willkommen zurück." : "So kannst du deine Briefe speichern."}
      </p>

      <div className="mt-6 space-y-3">
        {mode === "register" && (
          <div>
            <label className="text-sm text-slate-600">Name</label>
            <Input data-testid="auth-name" value={name} onChange={e => setName(e.target.value)} className="mt-1 h-12 rounded-2xl" />
          </div>
        )}
        <div>
          <label className="text-sm text-slate-600">E-Mail</label>
          <Input data-testid="auth-email" type="email" value={email} onChange={e => setEmail(e.target.value)} className="mt-1 h-12 rounded-2xl" />
        </div>
        <div>
          <label className="text-sm text-slate-600">Passwort</label>
          <Input data-testid="auth-password" type="password" value={password} onChange={e => setPassword(e.target.value)} className="mt-1 h-12 rounded-2xl" />
        </div>
      </div>

      <button
        onClick={submit}
        disabled={busy}
        data-testid="auth-submit"
        className="mt-6 w-full min-h-[56px] rounded-2xl bg-blue-600 text-white font-semibold flex items-center justify-center gap-2 disabled:bg-slate-300"
      >
        {busy && <Loader2 className="w-5 h-5 animate-spin" />}
        {mode === "login" ? "Anmelden" : "Registrieren"}
      </button>

      <button
        onClick={() => setMode(mode === "login" ? "register" : "login")}
        data-testid="auth-toggle"
        className="mt-3 w-full text-blue-700 text-sm font-medium py-2"
      >
        {mode === "login" ? "Noch kein Konto? Jetzt registrieren" : "Bereits ein Konto? Anmelden"}
      </button>
    </div>
  );
}
